export * from "@/components/comparison_group_list/table/table"
export * from "@/components/comparison_group_list/table/table_header"
export * from "@/components/comparison_group_list/table/table_row"
